import { useQuery } from '@tanstack/react-query';
import { counterpartyKeys } from '@/services/query-keys';
import { counterpartyService } from '@/services/counterparty/counterparty-service';

export const useCounterparties = (
  params?: Record<string, unknown>,
  /** `enabled` for callers that mount the hook on a screen which doesn't read
   *  it (a form in edit mode names the row's own counterparty). */
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: counterpartyKeys.list(JSON.stringify(params || {})),
    queryFn: () => counterpartyService.getCounterparties(params),
    staleTime: 5 * 60 * 1000,
    enabled: options?.enabled ?? true,
  });
};
